import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import type { ClientDocResponse } from '@/domain/models/client.js';
import { useApp } from '@/presentation/hooks/use-app.js';
import { ClientDocumentsTable } from '@/presentation/pages/clients/components/client-documents-table.js';

interface Props {
    documents: ClientDocResponse[];
    uploadingCategory: string | null;
    onUploadRequest: (category: string) => void;
    onDownload: (doc: ClientDocResponse) => void;
    onDeleteRequest: (docId: string) => void;
}

export function ClientDocsTab({ documents, uploadingCategory, onUploadRequest, onDownload, onDeleteRequest }: Props) {
    const { translate } = useApp();

    return (
        <Box>
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                    {translate('clients.tabs.docs')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {translate('clients.docsDesc')}
                </Typography>
            </Box>
            <ClientDocumentsTable
                documents={documents}
                uploadingCategory={uploadingCategory}
                onUploadRequest={onUploadRequest}
                onDownload={onDownload}
                onDeleteRequest={onDeleteRequest}
            />
        </Box>
    );
}
